/**
 * offlineprepreducer.js
 * Created by calhosh on 8/27/2020.
 */
import initialState from './initialstate';

export default function OfflinePrepReducer(state = initialState.offlinePrep, action) {
	switch (action.type) {
		case 'SET_OFFLINE_PREP':
			/* Notice that this is simply returning the action payload, <%=names.camel%>.
			 * This is because the combineReducers() call wraps this reducer
			 * and passes it only the portion of the store state that it
			 * is concerned with. */
			console.log(`[${action.type}]: OfflinePrep reducer -`, action);
			// if (_.isBoolean(action.isOnline)) {
			// 	return action.isOnline;
			// }
			return action.isCompleted;
		default:
			return state;
	}
}
